// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__U6cbs","icon":"spinner_icon__MbNpS","spin":"spinner_spin__xMFso"};